module.exports = __webpack_public_path__ + "img/tip-cake.b9211f41.png";